import { render, staticRenderFns } from "./process-data-dc.vue?vue&type=template&id=42d98625&"
import script from "./process-data-dc.vue?vue&type=script&lang=js&"
export * from "./process-data-dc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports